<template>
  <div class="">
    <div class="title">{{logReg}}</div>
    <transition name='fade'>
      <div class="">
        <div v-if="msg" :class="{'is-danger':isError, 'is-info':!isError}" class="notification is-light">{{msg}}</div>
      </div>
    </transition>
    <form action="#" @submit.prevent="submit">
      <div class="field">
        <label for="email" class="label">Email</label>

        <div class="control">
          <input
            id="email"
            type="email"
            class="input"
            name="email"
            value
            required
            autofocus
            v-model="form.email"
          />
        </div>
      </div>

      <div class="field">
        <label for="password" class="label"><span v-if="pass2Active">Set </span>Password</label>

        <div class="control">
          <input
            id="password"
            type="password"
            class="input"
            name="password"
            required
            v-model="form.password"
          />
        </div>
      </div>
      <transition name='fade'>
        <div v-if="pass2Active" class ='field'>
          <label for="password2" class="label">Confirm Password</label>

          <div class="control">
            <input
              id="password2"
              type="password"
              ref= "password"
              class="input"
              name="password2"
              required
              v-model="form.password2"
            />
          </div>
        </div>
      </transition>
      <transition name='fade'>
        <div v-if="pass2Active" class ='field'>
          <label for="username" class="label">Your Name</label>

          <div class="control">
            <input
              id="username"
              type="username"
              ref= "username"
              class="input"
              name="username"
              required
              v-model="form.username"
            />
          </div>
        </div>
      </transition>
      <div class="field" style="">
        <div class="control">
          <button id="loginBtn" type="submit" class="button is-fullwidth mt-5">{{logReg}}</button>
        </div>
      </div>
    </form>
    <router-link :to="{name: 'PasswordReset'}">Forgotton your password?</router-link>
  </div>
</template>

<script>
import { login, register, getLoggedInUser, watchUserData } from '@/firebaseService.js'
export default {
  data () {
    return {
      logReg: 'Login',
      allowReg: null,
      pass2Active: false,
      form: {
        email: '',
        password: '',
        password2: '',
        username: ''
      },
      isError: null,
      msg: ''
    }
  },
  props: {
  },
  methods: {
    storeUser () {
      getLoggedInUser().then(user => {
        watchUserData()
      })
    },
    submit () {
      login(this.form.email, this.form.password)
        .then(user => {
          this.storeUser()
        })
        .catch(err => {
          // Unregistered & using predefined password from config.js?
          if (err.code === 'auth/user-not-found' && this.$root.config.predefinedPassword.includes(this.form.password.toLowerCase())) {
            this.isError = null
            this.msg = 'Welcome new reader, please set your password'
            this.logReg = 'Register'
            this.form.password = ''
            this.allowReg = true
            this.pass2Active = true
          } else if (err.code === 'auth/user-not-found' && this.allowReg === true) {
            if (this.form.password === this.form.password2) {
              // Passwords match register user
              this.allowReg = null
              register(this.form.email, this.form.password, this.form.username)
                .then(user => {
                  // Set current uid in local storage
                  this.storeUser()
                })
                .catch(err => {
                  this.isError = true
                  this.msg = err.message
                })
            } else {
              // Misaligned passwords
              this.isError = true
              this.msg = 'Please ensure your passwords match'
            }
          } else {
            this.isError = true
            this.msg = err.message
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
.hidden {
  display: none;
}
</style>
